module.exports = __webpack_public_path__ + "static/media/skin-shine.4ab04cb4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/instore/icons/skin-shine.svg
// module id = 158
// module chunks = 0